import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/apiClient';
import type { ReleaseNotesResult } from '../types/releaseNotes';

export const useReleaseNotes = (releaseId: string | undefined) => {
  return useQuery<ReleaseNotesResult | null>({
    queryKey: ['releaseNotes', releaseId],
    queryFn: async () => {
      try {
        return await apiClient.getReleaseNotes(releaseId!);
      } catch (error: any) {
        // 404 means notes haven't been generated yet — return null
        if (error?.response?.status === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!releaseId,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};

export const useGenerateReleaseNotes = () => {
  const queryClient = useQueryClient();

  return useMutation<ReleaseNotesResult, Error, string>({
    mutationFn: (releaseId: string) => apiClient.generateReleaseNotes(releaseId),
    onSuccess: (data) => {
      queryClient.setQueryData(['releaseNotes', data.releaseId], data);
    },
  });
};
